import React from 'react';

const AutomationContext = React.createContext();
export default AutomationContext;